import React, { lazy } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/modules';

import { Navigate, Route, Routes } from 'react-router-dom';

import PATH from './path';

const MainBody = lazy(() => import('../components/2D/MainBody'));
const AboutBody = lazy(() => import('../components/2D/AboutBody'));
const LocationBody = lazy(() => import('../components/2D/LocationBody'));
const SolutionBodyDT = lazy(() => import('../components/2D/SolutionBodyDT'));
const SolutionBodyM = lazy(() => import('../components/2D/SolutionBodyM'));
const SolutionBodyVE = lazy(() => import('../components/2D/SolutionBodyVE'));
const SolutionBodyEdu = lazy(() => import('../components/2D/SolutionBodyEdu'));
const ProjectsBody = lazy(() => import('../components/2D/ProjectsBody'));
const ProjectsBodyDetail = lazy(
  () => import('../components/2D/ProjectsBodyDetail'),
);
const BlogBody = lazy(() => import('../components/2D/BlogBody'));
const BlogBodyDetail = lazy(() => import('../components/2D/BlogBodyDetail'));
const ContactBody = lazy(() => import('../components/2D/ContactBody'));
const IrBody = lazy(() => import('../components/2D/IrBody'));
const ContactBoardBody = lazy(
  () => import('../components/2D/ContactBoardBody'),
);
const VideoPreviewBody = lazy(
  () => import('../components/2D/VideoPreviewBody'),
);

const RouteHomepage = () => {
  const adminLogin = useSelector(
    (state: RootState) => state.hompate.adminLogin,
  );

  return (
    <Routes>
      <Route path={PATH.HOME} element={<MainBody />} />
      <Route path={PATH.MAIN} element={<MainBody />} />
      <Route path={PATH.ABOUT_US} element={<AboutBody />} />
      <Route path={PATH.LOCATION} element={<LocationBody />} />
      <Route path={PATH.SOL_DT} element={<SolutionBodyDT />} />
      <Route path={PATH.SOL_M} element={<SolutionBodyM />} />
      <Route path={PATH.SOL_VE} element={<SolutionBodyVE />} />
      <Route path={PATH.SOL_EDU} element={<SolutionBodyEdu />} />
      <Route path={PATH.PROJECTS_DETAIL} element={<ProjectsBodyDetail />} />
      <Route path={PATH.PROJECTS} element={<ProjectsBody />} />
      <Route path={PATH.BLOG} element={<BlogBody />} />
      <Route path={PATH.BLOG_DETAIL} element={<BlogBodyDetail />} />
      <Route path={PATH.CONTACT} element={<ContactBody />} />
      <Route path={PATH.IR} element={<IrBody />} />
      <Route path={PATH.SHOWROOM} element={<div>Showroom</div>} />
      {/* preview1: 의도적으로 빈 상태 (src 주석 처리) */}
      <Route
        path={PATH.VIDEO_PREVIEW}
        element={
          <VideoPreviewBody  src="/videos/semiconductor-demo.mp4" />
        }
      />
      <Route
        path={PATH.VIDEO_PREVIEW2}
        element={<VideoPreviewBody src="/videos/실감형_저작도구_preview2.mp4" />}
      />
      {/* preview3: 의도적으로 빈 상태 (src 주석 처리) */}
      <Route
        path={PATH.VIDEO_PREVIEW3}
        element={
          <VideoPreviewBody src="/videos/실감형_데모_preview1.mp4" />
        }
      />
      {adminLogin && (
        <Route path={PATH.ADMIN} element={<ContactBoardBody />} />
      )}
      <Route path="*" element={<Navigate to={PATH.HOME} />} />
    </Routes>
  );
};

export default React.memo(RouteHomepage);
